<mat-card appearance="outlined" class="mat-card-recording_info_gost">

  <div style="display: flex; flex-direction: column; height: 100%;">

    <mat-card-header>
      <mat-card-title i18n="@@home.gostRecording.title.protocol">プロトコル</mat-card-title>
      <mat-card-subtitle>{{ this.recordData?.data.recordTypeView}}</mat-card-subtitle>
    </mat-card-header>

    <mat-card-content class="protocol-detail">
      <div class="detail-area-row-gost-1">
        <div class="detail-area-col-gost" style="justify-content: space-evenly;">
          <div class="detail-area-row-gost" style="flex-wrap: nowrap; justify-content: center;">
            <div style="width: 120px; text-align: center; display: flex; flex-direction: column; justify-content: space-between;">
              <div style="margin-top: 1px;" i18n="@@home.gostRecording.label.stLevel">ST レベル</div>
              <div class="description1" i18n="@@home.gostRecording.label.stLevelDescription">水飲みテストだけの嚥下機能の評価 </div>
              <div style="" i18n="@@home.gostRecording.label.swallowingFunction">嚥下機能</div>
            </div>
            <div class="detail-items" style="width: 410px; display: flex; justify-content: center; flex-direction: column; align-items: center;">
              <div style="width: 100%; height: 20px; display: flex; justify-content: space-between;">
                <span style="width: 24px; text-align: center;">1</span>
                <span style="width: 24px; text-align: center;">2</span>
                <span style="width: 24px; text-align: center;">3</span>
                <span style="width: 24px; text-align: center;">4</span>
                <span style="width: 24px; text-align: center;">5</span>
                <span style="width: 24px; text-align: center;">6</span>
                <span style="width: 24px; text-align: center;">7</span>
                <span style="width: 24px; text-align: center; color: gray;">8</span>
              </div>
              <div style="width: 386px; align-self: left; margin-left: -16px; height: 30px; pointer-events: none;">
                <!-- TODO sliderをちゃんとする。valueとか -->
              <mat-slider class="gost_slider"  disabled [max]=8 [min]=1 [step]=1  discrete
                aria-labelledby="example-name-label" style="width: 100%; " >
                <input matSliderThumb [value]="this.recordData?.data?.gostScore ?? 0"/>
              </mat-slider>
            </div>
            <div style="width: 400px; display: flex; justify-content: space-between; padding-left: 8px; padding-right: 8px;">
              <span i18n="@@gost-recording.component.low">低い</span>
              <span i18n="@@gost-recording.component.high">高い</span>
            </div>
          </div>
        </div>

        <div class="detail-area-row-gost" style="flex-wrap: nowrap; justify-content: center;">
          <div style="width: 120px; text-align: center; display: flex; flex-direction: column; justify-content: space-between;">
            <div style="margin-top: 1px;" i18n="@@home.gostRecording.label.gostLevel">GOST レベル</div>
          </div>
          <div class="detail-items" style="width: 410px; display: flex; justify-content: center; flex-direction: column; align-items: center;">
            <!-- <div style="width:400px; height: 30px; pointer-events: none;"> -->
            <div style="width: 100%; height: 20px; display: flex; justify-content: space-between;">
              <span style="width: 24px; text-align: center;">1</span>
              <span style="width: 24px; text-align: center;">2</span>
              <span style="width: 24px; text-align: center;">3</span>
              <span style="width: 24px; text-align: center;">4</span>
              <span style="width: 24px; text-align: center;">5</span>
              <span style="width: 24px; text-align: center;">6</span>
              <span style="width: 24px; text-align: center;">7</span>
              <span style="width: 24px; text-align: center; color: gray;">8</span>
            </div>
            <div style="width: 386px; align-self: left; margin-left: -16px; height: 30px; pointer-events: none;">
              <mat-slider class="gost_slider"  disabled [max]=8 [min]=1 [step]=1  discrete
                aria-labelledby="example-name-label" style="width: 100%; " >
                <input matSliderThumb [value]="this.recordData?.data?.mGostScore?? 0" />
              </mat-slider>
            </div>
          <!-- </div> -->
          <div style="width:400px; height: 20px; display: flex; justify-content: space-between; padding-left: 8px; padding-right: 8px;">
            <span i18n="@@gost-recording.component.low">低い</span>
            <span i18n="@@gost-recording.component.high">高い</span>
          </div>
        </div>
      </div>

      <div class="detail-area-row-gost" style="flex-wrap: nowrap; justify-content: center;">
        <div style="width: 120px; margin-bottom: auto; margin-top: auto; text-align: center;">FOIS</div>
        <div class="detail-items" style="width: 410px; display: flex; justify-content: center; flex-direction: column; align-items: stretch;">
          <div style="display: flex; justify-content: space-between;">
            <div style="display: flex; flex-direction: column;">
              <mat-icon class="default-star" aria-hidden="false" aria-label="star" [ngClass]="{star: currentGost[0].stars >= 5}">{{ currentGost[0].stars >= 5 ? 'star' : 'star_outline'}}</mat-icon>
              <mat-icon class="default-star" aria-hidden="false" aria-label="star" [ngClass]="{star: currentGost[0].stars >= 4}">{{ currentGost[0].stars >= 4 ? 'star' : 'star_outline'}}</mat-icon>
              <mat-icon class="default-star" aria-hidden="false" aria-label="star" [ngClass]="{star: currentGost[0].stars >= 3}">{{ currentGost[0].stars >= 3 ? 'star' : 'star_outline'}}</mat-icon>
              <mat-icon class="default-star" aria-hidden="false" aria-label="star" [ngClass]="{star: currentGost[0].stars >= 2}">{{ currentGost[0].stars >= 2 ? 'star' : 'star_outline'}} </mat-icon>
              <mat-icon class="default-star" aria-hidden="false" aria-label="star" class="star">star</mat-icon>
            </div>
            <div style="display: flex; flex-direction: column;">
              <mat-icon class="default-star" aria-hidden="false" aria-label="star" [ngClass]="{star: currentGost[1].stars >= 5}">{{ currentGost[1].stars >= 5 ? 'star' : 'star_outline'}}</mat-icon>
              <mat-icon class="default-star" aria-hidden="false" aria-label="star" [ngClass]="{star: currentGost[1].stars >= 4}">{{ currentGost[1].stars >= 4 ? 'star' : 'star_outline'}}</mat-icon>
              <mat-icon class="default-star" aria-hidden="false" aria-label="star" [ngClass]="{star: currentGost[1].stars >= 3}">{{ currentGost[1].stars >= 3 ? 'star' : 'star_outline'}}</mat-icon>
              <mat-icon class="default-star" aria-hidden="false" aria-label="star" [ngClass]="{star: currentGost[1].stars >= 2}">{{ currentGost[1].stars >= 2 ? 'star' : 'star_outline'}} </mat-icon>
              <mat-icon class="default-star" aria-hidden="false" aria-label="star" class="star">star</mat-icon>
            </div>
            <div style="display: flex; flex-direction: column;">
              <mat-icon class="default-star" aria-hidden="false" aria-label="star" [ngClass]="{star: currentGost[2].stars >= 5}">{{ currentGost[2].stars >= 5 ? 'star' : 'star_outline'}}</mat-icon>
              <mat-icon class="default-star" aria-hidden="false" aria-label="star" [ngClass]="{star: currentGost[2].stars >= 4}">{{ currentGost[2].stars >= 4 ? 'star' : 'star_outline'}}</mat-icon>
              <mat-icon class="default-star" aria-hidden="false" aria-label="star" [ngClass]="{star: currentGost[2].stars >= 3}">{{ currentGost[2].stars >= 3 ? 'star' : 'star_outline'}}</mat-icon>
              <mat-icon class="default-star" aria-hidden="false" aria-label="star" [ngClass]="{star: currentGost[2].stars >= 2}">{{ currentGost[2].stars >= 2 ? 'star' : 'star_outline'}} </mat-icon>
              <mat-icon class="default-star" aria-hidden="false" aria-label="star" class="star">star</mat-icon>
            </div>
            <div style="display: flex; flex-direction: column;">
              <mat-icon class="default-star" aria-hidden="false" aria-label="star" [ngClass]="{star: currentGost[3].stars >= 5}">{{ currentGost[3].stars >= 5 ? 'star' : 'star_outline'}}</mat-icon>
              <mat-icon class="default-star" aria-hidden="false" aria-label="star" [ngClass]="{star: currentGost[3].stars >= 4}">{{ currentGost[3].stars >= 4 ? 'star' : 'star_outline'}}</mat-icon>
              <mat-icon class="default-star" aria-hidden="false" aria-label="star" [ngClass]="{star: currentGost[3].stars >= 3}">{{ currentGost[3].stars >= 3 ? 'star' : 'star_outline'}}</mat-icon>
              <mat-icon class="default-star" aria-hidden="false" aria-label="star" [ngClass]="{star: currentGost[3].stars >= 2}">{{ currentGost[3].stars >= 2 ? 'star' : 'star_outline'}} </mat-icon>
              <mat-icon class="default-star" aria-hidden="false" aria-label="star" class="star">star</mat-icon>
            </div>
            <div style="display: flex; flex-direction: column;">
              <mat-icon class="default-star" aria-hidden="false" aria-label="star" [ngClass]="{star: currentGost[4].stars >= 5}">{{ currentGost[4].stars >= 5 ? 'star' : 'star_outline'}}</mat-icon>
              <mat-icon class="default-star" aria-hidden="false" aria-label="star" [ngClass]="{star: currentGost[4].stars >= 4}">{{ currentGost[4].stars >= 4 ? 'star' : 'star_outline'}}</mat-icon>
              <mat-icon class="default-star" aria-hidden="false" aria-label="star" [ngClass]="{star: currentGost[4].stars >= 3}">{{ currentGost[4].stars >= 3 ? 'star' : 'star_outline'}}</mat-icon>
              <mat-icon class="default-star" aria-hidden="false" aria-label="star" [ngClass]="{star: currentGost[4].stars >= 2}">{{ currentGost[4].stars >= 2 ? 'star' : 'star_outline'}} </mat-icon>
              <mat-icon class="default-star" aria-hidden="false" aria-label="star" class="star">star</mat-icon>
            </div>
            <div style="display: flex; flex-direction: column;">
              <mat-icon class="default-star" aria-hidden="false" aria-label="star" [ngClass]="{star: currentGost[5].stars >= 5}">{{ currentGost[5].stars >= 5 ? 'star' : 'star_outline'}}</mat-icon>
              <mat-icon class="default-star" aria-hidden="false" aria-label="star" [ngClass]="{star: currentGost[5].stars >= 4}">{{ currentGost[5].stars >= 4 ? 'star' : 'star_outline'}}</mat-icon>
              <mat-icon class="default-star" aria-hidden="false" aria-label="star" [ngClass]="{star: currentGost[5].stars >= 3}">{{ currentGost[5].stars >= 3 ? 'star' : 'star_outline'}}</mat-icon>
              <mat-icon class="default-star" aria-hidden="false" aria-label="star" [ngClass]="{star: currentGost[5].stars >= 2}">{{ currentGost[5].stars >= 2 ? 'star' : 'star_outline'}} </mat-icon>
              <mat-icon class="default-star" aria-hidden="false" aria-label="star" class="star">star</mat-icon>
            </div>
            <div style="display: flex; flex-direction: column;">
              <mat-icon class="default-star" aria-hidden="false" aria-label="star" [ngClass]="{star: currentGost[6].stars >= 5}">{{ currentGost[6].stars >= 5 ? 'star' : 'star_outline'}}</mat-icon>
              <mat-icon class="default-star" aria-hidden="false" aria-label="star" [ngClass]="{star: currentGost[6].stars >= 4}">{{ currentGost[6].stars >= 4 ? 'star' : 'star_outline'}}</mat-icon>
              <mat-icon class="default-star" aria-hidden="false" aria-label="star" [ngClass]="{star: currentGost[6].stars >= 3}">{{ currentGost[6].stars >= 3 ? 'star' : 'star_outline'}}</mat-icon>
              <mat-icon class="default-star" aria-hidden="false" aria-label="star" [ngClass]="{star: currentGost[6].stars >= 2}">{{ currentGost[6].stars >= 2 ? 'star' : 'star_outline'}} </mat-icon>
              <mat-icon class="default-star" aria-hidden="false" aria-label="star" class="star">star</mat-icon>
            </div>
            <div style="display: flex; flex-direction: column;">
              <mat-icon class="default-star" aria-hidden="false" aria-label="star" [ngClass]="{star: currentGost[7].stars >= 5}">{{ currentGost[7].stars >= 5 ? 'star' : 'star_outline'}}</mat-icon>
              <mat-icon class="default-star" aria-hidden="false" aria-label="star" [ngClass]="{star: currentGost[7].stars >= 4}">{{ currentGost[7].stars >= 4 ? 'star' : 'star_outline'}}</mat-icon>
              <mat-icon class="default-star" aria-hidden="false" aria-label="star" [ngClass]="{star: currentGost[7].stars >= 3}">{{ currentGost[7].stars >= 3 ? 'star' : 'star_outline'}}</mat-icon>
              <mat-icon class="default-star" aria-hidden="false" aria-label="star" [ngClass]="{star: currentGost[7].stars >= 2}">{{ currentGost[7].stars >= 2 ? 'star' : 'star_outline'}} </mat-icon>
              <mat-icon class="default-star" aria-hidden="false" aria-label="star" class="star">star</mat-icon>
            </div>
          </div>
          <div style="width: 400px; align-self: center; padding: 8px; height: 30px;">
                <hr style="width: 100%;
                height: 2px;
                border: 0;
                border-top: 2px solid rgba(0,0,0,.38);"/>
          </div>
          <div style="height: 20px; display: flex; justify-content: space-between;">
            <span style="width: 24px; text-align: center;">1</span>
            <span style="width: 24px; text-align: center;">2</span>
            <span style="width: 24px; text-align: center;">3</span>
            <span style="width: 24px; text-align: center;">4</span>
            <span style="width: 24px; text-align: center;">5&nbsp;-</span>
            <span style="width: 24px; text-align: center;">5&nbsp;+</span>
            <span style="width: 24px; text-align: center;">6</span>
            <span style="width: 24px; text-align: center;">7</span>
          </div>
        </div>
      </div>
    </div>
    <div class="detail-area-col-gost">
      <div class="detail-area-row-gost" style="flex-direction: column;">
        <div style="height: 100%; display: flex; flex-direction: column;">
          <!-- <div style="border: solid; flex: 4;">
          top
        </div> -->
        <div class="data-details-title" style="font-size: 1em; margin-bottom: 10px;" i18n="@@home.gostRecording.title.waterTestResult">段階的水飲みテスト結果</div>
        <div style="flex: 2; display: flex; align-items: center; justify-content: center; padding-left: 20px; padding-right: 20px;">
          <div style="margin-top: 25px; margin-bottom: 10px;">
            <div #circle1 class="circle circle-none"></div>
            <div style="display: flex; height: 25px; align-items: flex-end; justify-content: center;">1 mL</div>
          </div>

          <span #dash1 style="width: 70px;" class=""></span>

          <div style="margin-top: 25px; margin-bottom: 10px;">
            <div #circle2 class="circle circle-none"></div>
            <div style="display: flex; height: 25px; align-items: flex-end; justify-content: center;">3 mL</div>
          </div>

          <span #dash2 style="width: 70px;" class=""></span>

          <div style="margin-top: 25px; margin-bottom: 10px;">
            <div #circle3 class="circle circle-none"></div>
            <div style="display: flex; height: 25px; align-items: flex-end; justify-content: center;">5 mL</div>
          </div>

          <span #dash3 style="width: 70px;" class=""></span>

          <div style="margin-top: 25px; margin-bottom: 10px;">
            <div #circle4 class="circle circle-none"></div>
            <div style="display: flex; height: 25px; align-items: flex-end; justify-content: center;">30 mL</div>
          </div>
        </div>
      </div>
    </div>

    <div class="detail-area-row-gost" style="">
      <div class="detail-items" style="display: flex; flex-direction: column; flex: 1;">
        <div class="data-details-title" style="font-size: 1em; margin-bottom: 10px;" i18n="@@home.gostRecording.label.bodyAngle">食事姿勢角度：<span>{{ this.recordData?.data.newsScore.bodyAngle }}</span> 度</div>
        <div #canvasContainer style="min-width: 300px; display: flex; flex-direction: column; align-items: center; justify-content: center;">
          <canvas #bodyAngleCanvas class="" style="width: 300px; height: 150px;">
          </canvas>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- <div class="detail-area-row-gost" style="width: 300px; justify-content: flex-start;">

</div> -->

<div class="detail-area-row-gost">
  <!-- <div class="detail-area-row-gost" style=""> -->
  <div class="detail-items" style="display: flex; flex-direction: column; overflow: auto; flex: 1;">

    <div class="data-details-title-left" style="margin-bottom: 10px; font-size: 1em;" i18n="@@home.gostRecording.title.foodFormTable">推奨食事形態対応表</div>

    <table class="s-table" style="">
      <tr class="s-tr">
        <td class="s-td-2">FOIS</td>
        <td class="s-td-2">{{ currentGost[0].fois.stringValue }}</td>
        <td class="s-td-2">{{ currentGost[1].fois.stringValue }}</td>
        <td class="s-td-2">{{ currentGost[2].fois.stringValue }}</td>
        <td class="s-td-2">{{ currentGost[3].fois.stringValue }}</td>
        <td class="s-td-2">{{ currentGost[4].fois.stringValue }}</td>
        <td class="s-td-2">{{ currentGost[5].fois.stringValue }}</td>
        <td class="s-td-2">{{ currentGost[6].fois.stringValue }}</td>
        <td class="s-td-2">{{ currentGost[7].fois.stringValue }}</td>
      </tr>

      <tr class="s-tr">
        <td class="s-td-2" i18n="@@home.gostRecording.label.swallowingFoodClassification">嚥下調整食分類2021</td>
        <td class="s-td-2"></td>
        <td class="s-td-2"></td>
        <td class="s-td-2" i18n="@@home.gostRecording.label.swallowingFood01">嚥下調整食0-1</td>
        <td class="s-td-2" i18n="@@home.gostRecording.label.swallowingFood2">嚥下調整食2</td>
        <td class="s-td-2" i18n="@@home.gostRecording.label.swallowingFood3">嚥下調整食3</td>
        <td class="s-td-2" i18n="@@home.gostRecording.label.swallowingFood4">嚥下調整食4</td>
        <td class="s-td-2"></td>
        <td class="s-td-2"></td>
      </tr>
      <tr class="s-tr">
        <td class="s-td"></td>
        <td class="s-td-2">{{ currentGost[0].fois.foodType }}</td>
        <td class="s-td-2">{{ currentGost[1].fois.foodType }}</td>
        <td class="s-td-2">{{ currentGost[2].fois.foodType }}</td>
        <td class="s-td-2">{{ currentGost[3].fois.foodType }}</td>
        <td class="s-td-2">{{ currentGost[4].fois.foodType }}</td>
        <td class="s-td-2">{{ currentGost[5].fois.foodType }}</td>
        <td class="s-td-2">{{ currentGost[6].fois.foodType }}</td>
        <td class="s-td-2">{{ currentGost[7].fois.foodType }}</td>
      </tr>
    </table>
  </div>
</div>

<div>
  <mat-divider></mat-divider>
  <div class="detail-area-bottom">
    <div>
      <div class="data-details-footer-title">Data ID</div>
      <div class="data-details-footer-value">
        <span>{{ this.recordData?.id }}</span>
      </div>
    </div>
    @if (this.recordData.data.gostRecordId != null) {
      <div>
        <div class="data-details-footer-title" i18n="@@home.gostRecording.label.recordId">レコードID</div>
        <div class="data-details-footer-value">
          <span>{{ this.recordData?.data.gostRecordId }}</span>
        </div>
      </div>
    }
    <div>
      <div class="data-details-footer-title" i18n="@@home.gostRecording.label.staff">スタッフ</div>
      <div class="data-details-footer-value">
        <span>{{ this.recordData?.meta.measurer.lastName }} {{ this.recordData?.meta.measurer.firstName }}</span>
      </div>
    </div>
    <div>
      <div class="data-details-footer-title" i18n="@@home.gostRecording.label.section">セクション</div>
      <div class="data-details-footer-value">
        <span>{{ this.recordData?.meta.location.sectionName }}</span>
      </div>
    </div>
    <div>
      <div class="data-details-footer-title" i18n="@@home.gostRecording.label.measurementDateTime">計測日時</div>
      <div class="data-details-footer-value">
        <span>{{ this.recordData.data.differentLocation ? (this.recordData?.data.createdAt | localDatetime) + '\n' + this.recordData?.data.createdAtLocationStr : (this.recordData?.data.createdAt | localDatetime) }}</span>
      </div>
    </div>
  </div>
</div>

</mat-card-content>

</div>

<mat-accordion>
  <mat-expansion-panel>
    <mat-expansion-panel-header>
      <mat-panel-title>
        機能障害度分類
      </mat-panel-title>
    </mat-expansion-panel-header>

    <table>
      <thead>
        <tr>
          <th i18n="@@home.gostRecording.label.functionalDisability">機能障害度</th>
          <th i18n="@@home.gostRecording.label.severe">重度（-3点）</th>
          <th i18n="@@home.gostRecording.label.moderate">中等度（-2点）</th>
          <th i18n="@@home.gostRecording.label.mild">軽度（-1点）</th>
          <th i18n="@@home.gostRecording.label.noSymptoms">無症状（0点）</th>
        </tr>
      </thead>
      <tbody>
        @for (row of rows; track row) {
          <tr>
            <td>{{ row.category }}</td>
            @for (value of row.values; track value) {
              <td>
                <input type="radio" [name]="row.category" [value]="value" [(ngModel)]="selectedValues[row.category]">
                {{ value }}
              </td>
            }
          </tr>
        }
      </tbody>
    </table>

  </mat-expansion-panel>

  <!-- Add more panels if needed -->

</mat-accordion>

</mat-card>
